(function () {
  const GALLERY_SELECTOR = 'ul[id^="Slider-Gallery-"]';
  const initializedGalleries = new WeakSet();

  function getLargestSrcFromSrcset(img) {
    const srcset = img.getAttribute('srcset');

    if (!srcset) {
      return img.currentSrc || img.src;
    }

    const candidates = srcset
      .split(',')
      .map((part) => part.trim())
      .map((part) => {
        const pieces = part.split(/\s+/);
        const url = pieces[0];
        const width = parseInt((pieces[1] || '').replace('w', ''), 10) || 0;
        return { url, width };
      })
      .filter((item) => item.url);

    if (!candidates.length) {
      return img.currentSrc || img.src;
    }

    candidates.sort((a, b) => b.width - a.width);

    return candidates[0].url;
  }

  function buildItems(gallery) {
    const items = [];

    gallery.querySelectorAll('.product__media-item').forEach((item) => {
      const img = item.querySelector('img');

      if (!img) return;

      items.push({
        src: getLargestSrcFromSrcset(img),
        thumbSrc: img.currentSrc || img.src,
        type: 'image',
        mediaId: item.getAttribute('data-media-id') || '',
        caption: img.getAttribute('alt') || '',
      });
    });

    return items;
  }

  function openFancyboxFromItem(gallery, item, event) {
    const items = buildItems(gallery);

    if (!items.length || typeof Fancybox === 'undefined') return;

    const clickedMediaId = item.getAttribute('data-media-id') || '';
    const startIndex = Math.max(
      items.findIndex((entry) => entry.mediaId === clickedMediaId),
      0
    );

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    Fancybox.show(
    items.map(({ mediaId, ...rest }) => rest),
    {
        startIndex,
        dragToClose: false,
        hideScrollbar: false,
        backdropClick: 'close',
        contentClick: 'toggleZoom',
        Images: {
        zoom: true,
        },
        Carousel: {
        Thumbs: false,
        Toolbar: {
            display: {
            left: ['infobar'],
            middle: [],
            right: ['zoomIn', 'close'],
            },
        },
        },
        l10n: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ZOOMIN: 'Zoom in',
        },
    }
    );
  }

  function onGalleryClick(event) {
    const gallery = event.currentTarget;
    const item = event.target.closest('.product__media-item');

    if (!item || !gallery.contains(item)) return;

    const img = item.querySelector('img');

    if (!img) return;

    openFancyboxFromItem(gallery, item, event);
  }

  function initGallery(gallery) {
    if (initializedGalleries.has(gallery)) return;

    initializedGalleries.add(gallery);

    gallery.addEventListener('click', onGalleryClick, true);
  }

  function init(root = document) {
    root.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();